import createBreakpoints from '@material-ui/core/styles/createBreakpoints';

export const breakpointsValues = {
  values: {
    xs: 0,
    sm: 600,
    md: 1024,
    md_two: 769,
    lg: 1280,
    xl: 1920,
  },
};

export const breakpoints = createBreakpoints({
  values: breakpointsValues.values,
});

export default breakpoints;
